
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Rater from 'vux/src/components/rater/index.vue'


export default {
components:{
XButton,
Group,
Cell,
Rater
},
data () {
return {
data: 0,
cont:'',
orderDetail:{},
flag:true,
disabled:false,
showLoading:false
}
},
methods : {
confirm(){
this.showLoading = true
let header = {
headers:{
token:localStorage.getItem('token'),
opid:localStorage.getItem('userid')
}
}
let obj = {
star:this.data,
rating:this.cont
}
let that = this
console.log(obj)
if(this.cont != ''){
this.$http.put('/api/v1/normalrepairs/'+ this.orderDetail.seq +'/comment',obj,header)
.then(res => {
console.log(res)
that.$router.push({name:'normalrepairslist'})
})
.catch(err => {
console.log(err.response)
this.showLoading = false
})
}
else{
this.$vux.alert.show({
title: '',
content: '评论信息不能为空'
})
this.showLoading = false
}
}
},
created(){
this.orderDetail = this.$route.params.obj
if(this.orderDetail.rating){
this.data = this.orderDetail.star
this.cont = this.orderDetail.rating
this.flag = false
this.disabled = true
}
},
beforeRouteEnter (to, from, next){
if(from.name != 'normaldone'){
next(vm => {
var order = localStorage.getItem('order')
vm.orderDetail = JSON.parse(order)
if(vm.orderDetail.rating){
vm.data = vm.orderDetail.star
vm.cont = vm.orderDetail.rating
vm.flag = false
vm.disabled = true
}
})
}
else {
next()
}
}
}



// WEBPACK FOOTER //
// ./src/components/userevaluation.vue